<template>
  <v-card class="pa-3 mb-4">
    <v-row class="w-100 overflow-x-auto flex-nowrap">
      <v-col cols="auto">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :disabled="isDisabled"
          bottom
          offset-y
          @update:model-value="onMenuUpdate"
        >
          <template #activator="{ props: activatorProps }">
            <v-chip
              color="primary"
              :disabled="isDisabled"
              v-bind="isDisabled ? {} : activatorProps"
              label
            >
              <v-icon v-if="isDisabled" start icon="mdi-lock-outline" />
              {{ $t("page.customer.search") }}
              <span v-if="hasQuery">&nbsp;|&nbsp;</span>
              <span v-if="hasQuery" class="font-weight-bold">{{ searchTerm }}</span>
              <v-btn
                v-if="hasQuery && !isDisabled"
                variant="text"
                size="x-small"
                icon="mdi-close"
                @click.stop="clearSearch"
              />
            </v-chip>
          </template>

          <v-card min-width="350" class="mt-2">
            <v-list>
              <v-list-item :title="$t('page.customer.filterBySearch')">
                <template #append>
                  <v-btn variant="text" icon="mdi-close" @click="menu = false" />
                </template>
              </v-list-item>
            </v-list>

            <v-divider />

            <v-text-field
              v-model="draftSearchTerm"
              class="mt-3 mx-6 pt-3"
              :label="$t('page.customer.searchPlaceholder')"
              prepend-inner-icon="mdi-magnify"
              clearable
              @keydown.enter="applyAndCloseFilter"
            />

            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" class="mr-2" @click="applyAndCloseFilter">
                {{ $t("page.payment.filter.applyFilter") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>

      <v-col class="d-flex justify-end">
        <v-btn
          v-if="hasQuery"
          variant="text"
          color="primary"
          class="mr-3"
          :disabled="isDisabled"
          @click="clearSearch"
        >
          {{ $t("page.payment.filter.clearFilters") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { useAuthStore } from "@/auth/stores/auth";
import { AccountPlan } from "@/shared/enums/status.enum";
import { useCustomersStore } from "@/customers/stores/customers";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const authStore = useAuthStore();
const customersStore = useCustomersStore();
const menu = ref(false);
const draftSearchTerm = ref("");

const searchTerm = computed(() =>
  typeof customersStore.query === "string" ? customersStore.query : "",
);
const hasQuery = computed(() => searchTerm.value.trim().length > 0);
const isDisabled = computed(() => props.disabled || authStore.accountPlan === AccountPlan.STARTER);

const onMenuUpdate = (isOpen: boolean) => {
  if (isOpen) draftSearchTerm.value = searchTerm.value;
};
const applyAndCloseFilter = () => {
  customersStore.setQuery(draftSearchTerm.value?.trim() || "");
  menu.value = false;
};
const clearSearch = () => {
  draftSearchTerm.value = "";
  customersStore.setQuery("");
};
</script>
